<template>
    <rkm-table
        :fields="fields"
        :items="data.form.declaracoesComparecimento.concat(data.model.declaracoesComparecimento)"
        hide-filters
        hide-pagination
        tag="div"
    >
        <template v-slot:cell(info)="row">
            <div v-if="Number.isInteger(row.item.id)">
                <rkm-icon
                    :id="`pronto-atendimento-declaracao-comparecimento-info-${row.item.id}`"
                    icon="info-circle"
                />

                <rkm-popover
                    :target="`pronto-atendimento-declaracao-comparecimento-info-${row.item.id}`"
                    triggers="hover"
                >
                    <div>{{ row.item.centroCusto.setor.nome }}</div>
                    <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                    <div>Class. risco: {{ row.item.classificacaoRisco.nome }}</div>
                    <div><rkm-icon :icon="['far', 'clock']" /> {{ row.item.dataHora }}</div>
                </rkm-popover>
            </div>
        </template>

        <template v-slot:cell(perfil)="row">
            {{ row.item.tipoId == enums.declaracaoComparecimentoTipo.PACIENTE ? 'Paciente' : 'Acompanhante' }}
        </template>

        <template v-slot:cell(actions)="row">
            <rkm-button
                color="primary"
                small
                title="Imprimir"
                @click="print(row.item)"
            >
                <rkm-icon icon="print" />
            </rkm-button>

            <rkm-button
                :disabled="Number.isInteger(row.item.id)"
                @click="$emit('edit', row.item)"
                color="primary"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="Number.isInteger(row.item.id)"
                @click="handleDestroy(row.item)"
                color="danger"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Enums.
import declaracaoComparecimentoTipo from '@/enums/pronto-atendimento/atendimento-medico/declaracaoComparecimentoTipo'

// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

import moment from 'moment'

export default {
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento.atendimentoMedico')
        }
    },
    data: () => ({
        enums: { declaracaoComparecimentoTipo },
        fields: [
            { key: 'info', label: '#' },
            { key: 'nome', label: 'Nome' },
            { key: 'perfil', label: 'Perfil' },
            { key: 'actions', label: 'Ações', class: 'col-min' },
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        print(item) {

            this.setLoading()

            const de = moment(moment(item.dataDe).format('YYYY-MM-DD') + ' ' + item.horaDe).format('YYYY-MM-DD HH:mm')
            const ate = moment(moment(item.dataAte).format('YYYY-MM-DD') + ' ' + item.horaAte).format('YYYY-MM-DD HH:mm')

            const data = {
                atendimentoId: this.data.model.atendimentoId,
                pacienteId: this.data.form.paciente.id,
                cid_id: this.data.model.cid ? this.data.model.cid.id : null,
                declaracoes: [
                    isNaN(item.id)
                        ? {
                            documentoTipoId: item.documentoTipoId,
                            documentoNumero: item.documentoNumero,
                            motivo: item.motivo,
                            nome: item.nome,
                            de,
                            ate,
                        }
                        : { id: item.id }
                ]
            }

            this.repositories.impressao[item.tipoId == this.enums.declaracaoComparecimentoTipo.PACIENTE
                ? 'declaracaoComparecimentoPaciente'
                : 'declaracaoComparecimentoAcompanhante'
            ](null, this.camelObjectKeysToSnakeRecursive(data))
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()

                    URL.revokeObjectURL(url);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                const index = this.data.model.declaracoesComparecimento.findIndex(dc => dc.id === item.id)
                resolve(this.data.model.declaracoesComparecimento.splice(index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        }
    },
    mixins: [repository, error, stringCase],
    props: {
        data: { type: Object, required: true },
    },
}
</script>